import { Injectable, inject } from '@angular/core';
import { MessageService, ToastMessageOptions } from 'primeng/api';

export enum ToastActionEnum {
  ActionCreate = 'action_create',
  ActionUpdate = 'action_update',
  ActionDelete = 'action_delete',
  ActionActivate = 'action_activate',
  ActionDeactivate = 'action_deactivate',
  ActionReassign = 'action_reassign',
  ActionClose = 'action_close',
  ActionCopy = 'action_copy',
  ActionEmail = 'action_email',
}

export enum ToastSeverityEnum {
  Success = 'success',
  Info = 'info',
  Warn = 'warn',
  Error = 'error',
}

const ToastSeverityMap = new Map([
  [ToastSeverityEnum.Error, 'Error'],
  [ToastSeverityEnum.Info, 'Info'],
  [ToastSeverityEnum.Warn, 'Warning'],
  [ToastSeverityEnum.Success, 'Success'],
]);

@Injectable({ providedIn: 'root' })
export class ToastService {
  private readonly messageService = inject(MessageService);

  private readonly defaultToastBehavior: Partial<ToastMessageOptions> = {
    life: 2000,
  };

  showToast(severity: ToastSeverityEnum, message: string, options?: Partial<ToastMessageOptions>): void {
    this.messageService.add({
      ...this.defaultToastBehavior,
      ...options,
      severity: severity,
      detail: options?.detail || message,
      summary: options?.summary || ToastSeverityMap.get(severity),
    });
  }
}
